module.exports = __webpack_public_path__ + "img/icon-kinopoisk.d4c123a1.svg";